import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interfaces/apiInterfaces';
import { IInitialState } from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  boleto: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  cartao: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  ted: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  pix: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  monthly: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  invoice: {
    grossIncome: 0,
    discount: 0,
    liquidIncome: 0,
  },
  card: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  cripto: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  tev: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
  domicilio: {
    received: 0,
    income: 0,
    passedOn: 0,
  },
};

export const getIncomeFaresFromApi = createAction(
  '@faresApp/incomeFares/GET_INCOME_FARES_FROM_API'
);

export const gotIncomeFaresFromApi = createAction<any>(
  '@faresApp/incomeFares/GOT_INCOME_FARES_FROM_API'
);

export const gotErrorFromIncomeFaresApi = createAction(
  '@faresApp/incomeFares/GOT_ERROR_FROM_INCOME_FARES_API'
);

export const displayIncomeFares = createAction<boolean>(
  '@faresApp/incomeFares/DISPLAY_INCOME_FARES'
);

export const logoutIncomeFaresApp = createAction(
  '@faresApp/incomeFares/LOGOUT_INCOME_FARES_APP'
);

const incomeReducer = createReducer(INITIAL_STATE, {
  [getIncomeFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotIncomeFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotError: false,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    ted: {
      received: action.payload.ted.recebido,
      passedOn: action.payload.ted.repasse,
      income: action.payload.ted.receita,
    },
    pix: {
      received: action.payload.pix.recebido,
      passedOn: action.payload.pix.repasse,
      income: action.payload.pix.receita,
    },
    boleto: {
      received: action.payload.boleto.recebido,
      passedOn: action.payload.boleto.repasse,
      income: action.payload.boleto.receita,
    },
    monthly: {
      received: action.payload.mensalidade.recebido,
      passedOn: action.payload.mensalidade.repasse,
      income: action.payload.mensalidade.receita,
    },
    card: {
      received: action.payload.cartao.recebido,
      passedOn: action.payload.cartao.repasse,
      income: action.payload.cartao.receita,
    },
    cripto: {
      received: action.payload.cripto.recebido,
      passedOn: action.payload.cripto.repasse,
      income: action.payload.cripto.receita,
    },
    invoice: {
      grossIncome: action.payload.nota.receita_bruta,
      discount: action.payload.nota.desconto,
      liquidIncome: action.payload.nota.receita_liquida,
    },
    cartao: {
      received: action.payload.cartao.recebido,
      passedOn: action.payload.cartao.repasse,
      income: action.payload.cartao.receita,
    },
    domicilio: {
      received: action.payload.domicilio.recebido,
      passedOn: action.payload.domicilio.repasse,
      income: action.payload.domicilio.receita,
    },
    tev: {
      received: action.payload.tev.recebido,
      passedOn: action.payload.tev.repasse,
      income: action.payload.tev.receita,
    },
  }),
  [gotErrorFromIncomeFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [displayIncomeFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutIncomeFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    dateSearch: {
      start: '',
      end: '',
    },
    income: {
      ted: 0,
      boleto: 0,
      monthly: 0,
    },
  }),
});

export default incomeReducer;
